import { createFileRoute, redirect } from "@tanstack/react-router";

import { DEFAULT_CUSTOMERS_SEARCH } from "@/customers/search";

/** Clients is the landing page; "/" only exists to send people there. */
export const Route = createFileRoute("/_authed/")({
  beforeLoad: () => {
    throw redirect({ to: "/customers", search: DEFAULT_CUSTOMERS_SEARCH });
  },
});
